var map = {
	"./frontend/AndroidGuide.vue": 97881,
	"./frontend/Banking.vue": 26049,
	"./frontend/BetslipHistory.vue": 85514,
	"./frontend/BodyFB.vue": 78078,
	"./frontend/Commission.vue": 90567,
	"./frontend/ContactUs.vue": 35571,
	"./frontend/DataTable.vue": 36107,
	"./frontend/Deposit.vue": 95873,
	"./frontend/DepositOld.vue": 87496,
	"./frontend/History.vue": 64489,
	"./frontend/HistoryOld.vue": 90914,
	"./frontend/Home.vue": 30896,
	"./frontend/HomeOld.vue": 56135,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe copy.vue": 34991,
	"./frontend/Iframe.vue": 74099,
	"./frontend/Index.vue": 9803,
	"./frontend/Live.vue": 61005,
	"./frontend/LiveScore.vue": 72184,
	"./frontend/MainMenu.vue": 43595,
	"./frontend/MaungFB.vue": 84844,
	"./frontend/Promotion.vue": 55180,
	"./frontend/Setting.vue": 65821,
	"./frontend/SettingOld.vue": 34039,
	"./frontend/VideoLink.vue": 96211,
	"./frontend/VipLevels.vue": 79832,
	"./frontend/Withdraw.vue": 45817,
	"./frontend/auth/Login.vue": 33996,
	"./frontend/auth/Register.vue": 75383,
	"./frontend/auth/Rule.vue": 24557,
	"./frontend/auth/Verify.vue": 99823,
	"./frontend/auth/VerifyNotAuth.vue": 2395,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 86329,
	"./frontend/components/DataTableOld.vue": 89830,
	"./frontend/components/FBPreviewVoucher.vue": 63294,
	"./frontend/components/FBVoucher.vue": 67050,
	"./frontend/components/FootballTeamCard.vue": 62860,
	"./frontend/components/GameCard.vue": 20229,
	"./frontend/components/GroupBox.vue": 48747,
	"./frontend/components/HotGameSection.vue": 43676,
	"./frontend/components/InputSelectDrawModal.vue": 81314,
	"./frontend/components/LuckyWheel.vue": 30187,
	"./frontend/components/NormalBox.vue": 11325,
	"./frontend/components/PreviewVoucher.vue": 69178,
	"./frontend/components/ProviderCardOld.vue": 17581,
	"./frontend/components/SideNav.vue": 30850,
	"./frontend/components/Table.vue": 47278,
	"./frontend/components/ThreedGroupBox.vue": 95959,
	"./frontend/components/TwoDSelect.vue": 89795,
	"./frontend/components/Voucher.vue": 17182,
	"./frontend/normal-user/2d/2d.vue": 37189,
	"./frontend/normal-user/2d/ClosedDays.vue": 65832,
	"./frontend/normal-user/2d/Home.vue": 90292,
	"./frontend/normal-user/2d/Winner.vue": 81077,
	"./frontend/normal-user/3d/3d.vue": 36456,
	"./frontend/normal-user/3d/Home.vue": 26470,
	"./frontend/normal-user/DreamBooks.vue": 46314,
	"./frontend/normal-user/Index.vue": 88472,
	"./frontend/normal-user/bugyee/Room.vue": 58347,
	"./frontend/normal-user/game/Arcade.vue": 24014,
	"./frontend/normal-user/game/Fishing.vue": 36094,
	"./frontend/normal-user/game/Game.vue": 91217,
	"./frontend/normal-user/game/Live.vue": 14370,
	"./frontend/normal-user/game/Slot.vue": 28473,
	"./frontend/normal-user/game/Sport.vue": 77460,
	"./frontend/normal-user/shankomee/Room.vue": 55692,
	"./frontend/promotions/Index.vue": 78588,
	"./frontend/promotions/components/NoPromotions.vue": 3704,
	"./frontend/promotions/components/PromotionCard.vue": 35121,
	"./frontend/user/components/PromotionCard.vue": 20808,
	"./frontend/user/promotions/Index.vue": 88269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;